export default __webpack_public_path__ + "static/media/maintenance.29b49ce2.jpeg";